var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.01,
    height: 35.708,
    viewBox: "0 0 42.01 35.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.055,18.327l18.9,10.917a2.1,2.1,0,0,0,2.1,0l18.9-10.917a2.1,2.1,0,0,0,0-3.632L24.05,3.777a2.1,2.1,0,0,0-2.1,0L3.055,14.695a2.1,2.1,0,0,0,0,3.632ZM23,8.018l14.7,8.4L23,24.919,8.3,16.5ZM40.846,24.373,23,34.682,5.154,24.373a2.1,2.1,0,1,0-2.1,3.632l18.9,10.917a2.1,2.1,0,0,0,2.1,0l18.9-10.917a2.1,2.1,0,1,0-2.1-3.632Z",
    transform: "translate(-1.995 -3.496)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.6c18a6476444dce250b8288b79afaec8.svg";
export { ForwardRef as ReactComponent };